import React, { useMemo } from 'react';
import LineChartComponent from './LineChartComponent';
import TableComponent from './TableComponent';
import styles from './Report.module.css';
import { summrizeTableData } from './utils.js';
import { formatTime } from '../../utils/timeUtils.js';
import Utility from '../../utils/Utilty.js';

const Report = ({ record,setShowReport }) => {
  if (!record) {
    return (
      <div className={styles.a4Style}>
        <div className={styles.title}>
          <h1 style={{ color: 'red' }}>Error: No Data</h1>
        </div>
      </div>
    );
  }


  // データ成型処理（既存ロジック）
  const data = useMemo(() => summrizeTableData(record.datas), [record.datas]);

  
  /** 戻るボタンを押された際の処理 */
  const handleClickBackButton = () => {
    setShowReport(false);
  };

  return (
    <div>
      <div className={styles.mask}></div>
      <div className={styles.a4Style}>
        {/* タイトル部分 */}
        <div className={styles.title}>
          <h1>土　壌　微　生　物　観　測　票</h1>
        </div>

        {/* レポート基本情報 */}
        <div className={styles.tableLeft}>
          <table>
            <tbody>
              <tr>
                <td>
                  観測番号
                </td>
              </tr>
              <tr>
                <td>
                  {record.recordId}
                </td>
              </tr>
              <tr>
                <td>観測地域</td>
                <td>基準緯度</td>
                <td>基準経度</td>
                <td>観測半径<i>(m)</i></td>
                <td>観測面積<i>(㎢)</i></td>
              </tr>
              <tr>
                <td>{record.address.specific}<br/>{record.address.prefecture}&nbsp;{record.address.city}</td>
                <td>{Utility.roundToDecimal(record.lat,5)}</td>
                <td>{Utility.roundToDecimal(record.lng,5)}</td>
                <td>{Utility.roundToDecimal(record.r,2)}</td>
                <td>{Utility.roundToDecimal(record.area,3)}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className={styles.tableTopRight}>
          <table>
            <tbody>
              <tr>
                <td>調査年月日</td>
                <td>{record.yyyymmdd}</td>
              </tr>
              <tr>
                <td>観測時刻</td>
                <td>{record.hhmmss}</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* 折れ線グラフとテーブルを表示する領域 */}
        <div className={styles.content}>
          <div>
            <LineChartComponent lineData={data.line} />
          </div>
          <div style={{paddingTop: '30px'}}>
            <TableComponent tableData={data.table} hours={record.hours} />
          </div>
        </div>
      </div>
      {/* ボタン */}
      <div style={{ padding: '50px', textAlign: 'center' }}>
        <button
          className={`${styles.backButton} no-print`}
          onClick={handleClickBackButton}
          style={{
            fontFamily: '"ヒラギノ明朝 ProN", "Hiragino Mincho ProN", "Yu Mincho", "游明朝", "MS PMincho", "MS Mincho", serif',
            fontSize: '16px',
            padding: '10px 20px',
            backgroundColor: '#f5f5f5', // グレー背景
            color: '#333', // 黒文字
            border: '0px solid #ccc',
            borderRadius: '4px',
            cursor: 'pointer',
            transition: 'background-color 0.3s, color 0.3s',
          }}
          onMouseOver={(e) => {
            e.target.style.backgroundColor = '#333';
            e.target.style.color = '#fff';
          }}
          onMouseOut={(e) => {
            e.target.style.backgroundColor = '#f5f5f5';
            e.target.style.color = '#333';
          }}
        >
          Back to Simulator
        </button>
      </div>
      
    </div>
  );
};

export default Report;
